<div class="backGround d-flex align-items-center justify-content-center">
  <div class="text-center">
    <p class="titles">ISC</p>
    <p class="subTitle w-75 mx-auto">
      أسعار تنافسية للقوى العاملة ، والقرب من الأسواق العالمية مع بنية تحتية
      متطورة بالاضافة إلى ان مصر لديها إمكانية الوصول إلى الأسواق الرئيسية
      كبيرة.
    </p>
    <button class="btnGreen">إقرأ المزيد</button>
  </div>
</div>